import * as React from "react";
import Ajax from "../../Ajax";
import TypeEdit from "./TypeEdit";

interface IFormProps {
  types: object
}
interface MyStates {
  ajaxLoaded: boolean,
}
export default class TypesList extends React.Component<IFormProps, MyStates>{

  constructor(props:IFormProps) {
    super(props);
    
    this.state = {
      ajaxLoaded: true,
    }
  }

  public render() {
    return (
      <>
        {
          Object.keys(this.props.types).map( (i) => {
            return (
              <div key={'type_' + i}>
                <TypeEdit type={this.props.types[i]} />
              </div>
            )
          })
        }
      </>
    )
  }
}